import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../nav_bar/Navbar";
import Footer from "../../footer/Footer";
import { fetchIpaSymbols } from "./ipaService";
import "./IpaPage.css";

const difficultyOptions = ["BEGINNER", "INTERMEDIATE", "ADVANCED"];
const typeOptions = ["VOWEL", "CONSONANT", "DIPHTHONG", "SUPRASEGMENTAL"];

const difficultyColor = (d) => {
  const map = { BEGINNER: "#4caf50", INTERMEDIATE: "#ff9800", ADVANCED: "#e91e63" };
  return map[d?.toUpperCase()] || "#999";
};

const IpaSymbolListPage = () => {
  const [symbols, setSymbols] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [difficulty, setDifficulty] = useState("");
  const [type, setType] = useState("");
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const navigate = useNavigate();

  const load = useCallback(async () => {
    setLoading(true);
    const res = await fetchIpaSymbols({ page, size: 20, search: search || undefined, difficulty: difficulty || undefined, type: type || undefined });
    if (res.status === 200 && res.data?.status) {
      setSymbols(res.data.data || []);
      setTotalPages(res.data.totalPages || 0);
      setTotalItems(res.data.totalItems || 0);
    } else {
      setSymbols([]);
      setTotalPages(0);
      setTotalItems(0);
    }
    setLoading(false);
  }, [page, search, difficulty, type]);

  useEffect(() => { load(); }, [load]);

  const handleDifficulty = (val) => { setPage(0); setDifficulty(difficulty === val ? "" : val); };

  return (
    <>
      <Navbar />
      <div className="ipa-page">
        <h1 className="ipa-title">🗣️ IPA Symbols</h1>
        <p className="ipa-subtitle">Master the International Phonetic Alphabet — tap a sound to learn more.</p>

        <div className="ipa-tabs">
          {difficultyOptions.map((d) => (
            <button key={d} className={`ipa-tab ${difficulty === d ? "active" : ""}`} onClick={() => handleDifficulty(d)}>
              {d.charAt(0) + d.slice(1).toLowerCase()}
            </button>
          ))}
        </div>

        <div className="ipa-filters">
          <input
            className="ipa-search"
            type="text"
            placeholder="Search symbols..."
            value={search}
            onChange={(e) => { setPage(0); setSearch(e.target.value); }}
          />
          <select className="ipa-filter-select" value={type} onChange={(e) => { setPage(0); setType(e.target.value); }}>
            <option value="">All Types</option>
            {typeOptions.map((t) => (
              <option key={t} value={t}>{t}</option>
            ))}
          </select>
        </div>

        {totalItems > 0 && <p className="ipa-count">{totalItems} symbols found</p>}

        {loading ? (
          <p className="ipa-loading">Loading...</p>
        ) : symbols.length === 0 ? (
          <p className="ipa-empty">No symbols found.</p>
        ) : (
          <div className="ipa-symbol-grid">
            {symbols.map((s) => (
              <div key={s.id} className="ipa-symbol-card" onClick={() => navigate(`/study/ipa/symbols/${s.id}`)}>
                <div className="ipa-symbol-char">{s.symbol}</div>
                <div className="ipa-symbol-example">{s.exampleWord}</div>
                <div className="ipa-symbol-ipa">{s.exampleIpa}</div>
                <span className="ipa-difficulty-badge" style={{ background: difficultyColor(s.difficulty) }}>
                  {s.difficulty}
                </span>
              </div>
            ))}
          </div>
        )}

        {totalPages > 1 && (
          <div className="ipa-pagination">
            <button disabled={page === 0} onClick={() => setPage(page - 1)}>← Prev</button>
            <span>Page {page + 1} / {totalPages}</span>
            <button disabled={page + 1 >= totalPages} onClick={() => setPage(page + 1)}>Next →</button>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default IpaSymbolListPage;
